import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
    CampaignOverviewQueryQuery,
    QueryCampaignOverviewArgs 
} from "../../../../../schemaTypes";

export const campaignOverviewQuery = gql`
  query CampaignOverviewQuery(
    $duration: String!
    $typeFilter: String
  ) {
    campaignOverview(
      duration: $duration
      typeFilter: $typeFilter 
    ) {
        totalCampaigns
        totalImpressions
        totalClicks
        activeCampaigns
        expiredCampaigns
    }
  }
`;

export interface WithCampaignOverview {
  loading: boolean;
  totalCampaigns: number;
  totalImpressions: number;
  totalClicks: number;
  activeCampaigns: number;
  expiredCampaigns: number;
}

interface Props {
  variables: QueryCampaignOverviewArgs;
  children: (data: WithCampaignOverview) => React.ReactElement | null;
}

export const CampaignOverviewController: React.FC<Props> = ({
  children,
  variables,
}) => {
  const { data, loading } = useQuery<
    CampaignOverviewQueryQuery,
    QueryCampaignOverviewArgs
  >(campaignOverviewQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const totalCampaigns = Number(data?.campaignOverview?.totalCampaigns || 0);
  const totalImpressions = Number(data?.campaignOverview?.totalImpressions || 0);
  const totalClicks = Number(data?.campaignOverview?.totalClicks || 0);
  const activeCampaigns = Number(data?.campaignOverview?.activeCampaigns || 0);
  const expiredCampaigns = Number(data?.campaignOverview?.expiredCampaigns || 0);

  return children({
    loading,
    totalCampaigns,
    totalImpressions,
    totalClicks,
    activeCampaigns,
    expiredCampaigns
  });
};